// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const LinkedIn: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
            <g fill="none" fillRule="evenodd">
                <rect width="31" height="31" x=".5" y=".5" stroke="#FFF" opacity=".33" />
                <path
                    fill="#FFF"
                    d="M20.0379365,13.5834599 C18.4737372,13.5834599 17.4944929,14.4487663 17.3130828,15.0548084 L17.3130828,13.6686334 L14.2476225,13.6686334 C14.2874216,14.4043076 14.2476225,22.5 14.2476225,22.5 L17.3130828,22.5 L17.3130828,17.7213934 C17.3130828,17.4551093 17.3015133,17.1897612 17.380186,16.9992908 C17.5912141,16.4681265 18.043351,15.9173068 18.8573825,15.9173068 C19.9222412,15.9173068 20.4058472,16.7334747 20.4058472,17.9301153 L20.4058472,22.5 L23.5,22.5 L23.5,17.5894214 C23.5,14.8540423 21.9765254,13.5834599 20.0379365,13.5834599 M9.85324062,22.5 L12.5822593,22.5 L12.5822593,13.6686334 L9.85324062,13.6686334 L9.85324062,22.5 Z M11.1669366,9.5 C10.1594627,9.5 9.5,10.1612644 9.5,11.0335906 C9.5,11.8886013 10.1404887,12.5639053 11.128063,12.5639053 L11.1474998,12.5639053 C12.173485,12.5639053 12.8125853,11.8867294 12.8125853,11.0307827 C12.7931485,10.1593925 12.173485,9.5 11.1669366,9.5"
                />
            </g>
        </svg>
    );
};

export default React.memo(LinkedIn);
